"use client";

import React from "react";
import { useTranslations } from "@/lib/i18n-client";
import { Search, Mail } from "lucide-react";

/**
 * Decorative phone mockup floating over the hero photo — mirrors the
 * Travel Connected homepage on a device. Static / export-safe / claim-safe.
 */
export default function PhoneMockup() {
  const { t } = useTranslations();

  return (
    <div className="pc-card rounded-[2rem] p-2 shadow-xl">
      <div className="rounded-[1.6rem] bg-card overflow-hidden border border-border">
        <div className="flex items-center justify-between px-4 pt-2 text-[10px] text-muted-foreground">
          <span>9:41</span>
          <span>5G</span>
        </div>
        <div className="px-4 pb-4 pt-3">
          <div className="text-xs font-extrabold text-foreground">eSIM</div>
          <div className="mt-2 text-base font-extrabold text-foreground leading-tight">
            {t("pc.hero.title", "Travel connected in minutes.")}
          </div>
          <div className="mt-3 rounded-lg border border-border bg-background p-2 flex items-center gap-1.5">
            <Search className="w-3.5 h-3.5 text-muted-foreground" />
            <span className="text-[10px] text-muted-foreground">{t("pc.hero.searchLabel", "Where are you traveling to?")}</span>
          </div>
          <div className="mt-2.5 rounded-full bg-primary text-primary-foreground text-[11px] font-bold text-center py-1.5">
            {t("pc.hero.cta", "Find my eSIM")}
          </div>
          <div className="mt-2 inline-flex items-center gap-1 text-[9px] text-muted-foreground">
            <Mail className="w-3 h-3 text-primary" />
            {t("pc.hero.delivery", "Instant delivery to your email.")}
          </div>
        </div>
      </div>
    </div>
  );
}
